export default "__VITE_ASSET__BtDMk2ED__"